import { render, staticRenderFns } from "./km.vue?vue&type=template&id=1c70fd50&"
import script from "./km.vue?vue&type=script&lang=js&"
export * from "./km.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports